export default "__VITE_ASSET__DQgxyQ4M__"